import { createFileRoute } from "@tanstack/react-router";
import { WorkflowList } from "@/components/views/workflow/WorkflowList";
import { currentUserId } from "@/data";

export const Route = createFileRoute("/saved-workflows")({
  component: SavedWorkflowsRoute,
});

function SavedWorkflowsRoute() {
  return <WorkflowList scope={(w) => w.authorId === currentUserId} />;
}
